import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { CustomerTableComponent } from './customer-table.component';
import { CustomerTableTotalizersModule } from './customer-table-totalizers/customer-table-totalizers.module';

@NgModule({
  declarations: [CustomerTableComponent],
  exports: [CustomerTableComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    CustomerTableTotalizersModule
  ],
})
export class CustomerTableModule {}
